import { Component, forwardRef, Input, OnChanges, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-form-button',
  template: `
    <button [type]="type" [class.--loading]="loading" [disabled]="disabled">
      <!-- [style.background-image]="cssBackground" -->
      <span *ngIf="icon && iconPosition === 'left'" class="icon-left"><i [class]="icon"></i></span>
      <ng-content></ng-content>
      <span *ngIf="icon && iconPosition === 'right'" class="icon-right"><i [class]="icon"></i></span>
    </button>
  `,
  styleUrls: ['./form-button.template.scss'],
  // styles: [':host{pointer-events: none}'],
})
export class FormButtonComponent {
  @Input() type: string = 'button';
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() icon: string = '';
  @Input('icon-position') iconPosition: string = 'left';

  constructor() {}
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/form/buttons/form-button.component.ts